"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirect = exports.req = void 0;
var reconnect_js_1 = require("reconnect.js");
var outletName = 'ApiUtil';
function redirect(url) {
  var modifyRedirectUrl = (reconnect_js_1.hasOutlet(outletName) && reconnect_js_1.getOutlet(outletName).getValue() || {}).modifyRedirectUrl;
  if (modifyRedirectUrl) {
    url = modifyRedirectUrl(url);
  }
  window.location.href = url;
}
exports.redirect = redirect;
function req(url_, _a, options) {
  if (_a === void 0) {
    _a = {};
  }
  if (options === void 0) {
    options = {};
  }
  var _b = _a.method,
    method = _b === void 0 ? 'GET' : _b,
    _c = _a.headers,
    headers = _c === void 0 ? {} : _c,
    data = _a.data,
    restOptions = __rest(_a, ["method", "headers", "data"]);
  return __awaiter(this, void 0, void 0, function () {
    var _d, onJson, onError, modifyFetchArgs, ignoreOnErrorHook, ignoreStatusCheck, fetchArgs, resp, url, fetchPayload, jsonResp, ex_1, err, _e, ex_2;
    return __generator(this, function (_f) {
      switch (_f.label) {
        case 0:
          _d = reconnect_js_1.hasOutlet(outletName) && reconnect_js_1.getOutlet(outletName).getValue() || {}, onJson = _d.onJson, onError = _d.onError, modifyFetchArgs = _d.modifyFetchArgs;
          ignoreOnErrorHook = options.ignoreOnErrorHook, ignoreStatusCheck = options.ignoreStatusCheck;
          fetchArgs = [url_, __assign(__assign({
            method: method,
            headers: __assign({
              'Content-Type': 'application/json'
            }, headers)
          }, method !== 'GET' && data ? {
            body: JSON.stringify(data)
          } : {}), restOptions)];
          if (modifyFetchArgs) {
            fetchArgs = modifyFetchArgs.apply(void 0, fetchArgs);
          }
          return [4 /*yield*/, fetch.apply(void 0, fetchArgs)];
        case 1:
          resp = _f.sent();
          url = fetchArgs[0];
          fetchPayload = fetchArgs[1];
          if (!(ignoreStatusCheck || 200 <= resp.status && resp.status < 400)) return [3 /*break*/, 6];
          _f.label = 2;
        case 2:
          _f.trys.push([2, 4,, 5]);
          return [4 /*yield*/, resp.json()];
        case 3:
          jsonResp = _f.sent();
          if (typeof onJson === 'function') {
            return [2 /*return*/, onJson(url, fetchPayload, jsonResp)];
          } else {
            return [2 /*return*/, jsonResp];
          }
          return [3 /*break*/, 5];
        case 4:
          ex_1 = _f.sent();
          return [3 /*break*/, 5];
        case 5:
          // we cannot perform resp.json(), but we still consider it is a success fetch
          // without any payload
          return [2 /*return*/, null];
        case 6:
          if (!(!ignoreOnErrorHook && typeof onError === 'function')) return [3 /*break*/, 8];
          // don't return, so if the hook doesn't throw an exception,
          // the flow will continue to execute
          return [4 /*yield*/, onError(url, fetchPayload, resp)];
        case 7:
          // don't return, so if the hook doesn't throw an exception,
          // the flow will continue to execute
          _f.sent();
          _f.label = 8;
        case 8:
          err = {
            status: resp.status,
            response: undefined
          };
          _f.label = 9;
        case 9:
          _f.trys.push([9, 11,, 12]);
          _e = err;
          return [4 /*yield*/, resp.json()];
        case 10:
          _e.response = _f.sent();
          return [3 /*break*/, 12];
        case 11:
          ex_2 = _f.sent();
          return [3 /*break*/, 12];
        case 12:
          throw err;
      }
    });
  });
}
exports.req = req;